import {set_cookie} from "../tools/cookies";

export const modal = () => {
  const btn_close = document.querySelectorAll('.modal .close');

  if (btn_close.length > 0) {
    btn_close.forEach(btn => {
      btn.addEventListener('click', event => {
       // event.preventDefault();

        const modal = btn.closest('.modal');
        modal.classList.remove('active');


        set_cookie('dm_ino', 'hide');
        document.body.classList.remove('modal-active');
        document.body.classList.remove('modal-show');

        setTimeout(() => {
          modal.classList.add('hide');
        }, 500)
      })
    })
  }
}
